export default __webpack_public_path__ + "static/media/over-size.498697ae.svg";